import React from "react";
import { fetchInvoice } from "../../api/billingApi.js";
import { invoiceLineItems } from "../../utils/billingInvoiceGroups.js";
import BillableCalculationPanel from "./BillableCalculationPanel.jsx";

// Prestations du relevé tirées de ses lignes enregistrées : résumé de la carte et « Expliquer au client ».
export const invoiceAccountItems = (invoice) => invoiceLineItems(invoice.lines || invoice.invoice_lines || []).map((line) => ({
  ...line, currency_code: invoice.currency_code || "CAD",
  // Les lignes ne portent pas l'entreprise : l'explication la reprend du relevé.
  billing_account_id: invoice.billing_account_id, billing_account_name: invoice.billing_account_name || invoice.billing_account_snapshot?.name,
}));

// Total du relevé et ses composantes (surtaxe, TPS, TVQ), repris tels qu'enregistrés.
export const invoiceStatementTotals = (invoice) => ({
  subtotal: invoice.subtotal, surcharge: invoice.fuel_surcharge_amount, surchargePercent: invoice.fuel_surcharge_percent,
  gst: invoice.gst_amount, gstPercent: invoice.gst_rate_percent, qst: invoice.qst_amount, qstPercent: invoice.qst_rate_percent,
  total: invoice.total, currency: invoice.currency_code || "CAD",
});

// Le résumé utilise les lignes enregistrées du relevé, comme son détail.
export default function InvoiceCalculationPanel({ invoiceId, id, refreshKey, onLoad }) {
  const [invoice, setInvoice] = React.useState(null);
  const [error, setError] = React.useState("");
  const [attempt, setAttempt] = React.useState(0);
  React.useEffect(() => {
    const controller = new AbortController();
    setInvoice(null);
    setError("");
    fetchInvoice(invoiceId, { signal: controller.signal }).then((result) => {
      if (controller.signal.aborted) return;
      setInvoice(result);
      onLoad?.(result);
    }).catch((failure) => {
      if (!controller.signal.aborted) setError(failure.message || "Le résumé ne peut pas être chargé.");
    });
    return () => controller.abort();
  }, [invoiceId, refreshKey, attempt]);
  const account = React.useMemo(() => {
    if (!invoice) return null;
    const items = invoiceAccountItems(invoice);
    return {
      label: invoice.billing_account_name || invoice.billing_account_snapshot?.name || invoice.billing_account?.name || invoice.client_name || "Entreprise",
      items, blockedCount: 0, statementTotals: invoiceStatementTotals(invoice),
    };
  }, [invoice]);
  if (!account) return <section id={id} aria-label="Résumé du relevé" className="billable-calculation-panel rounded-[4px] border border-slate-300 bg-white px-3 py-2">
    {error ? <div role="alert" className="text-sm text-red-800">{error}
      <button type="button" onClick={() => setAttempt((value) => value + 1)} className="ml-2 cursor-pointer rounded-[4px] border border-slate-300 bg-white px-2 text-slate-700 hover:bg-slate-50 focus-visible:outline-2 focus-visible:outline-accent">Réessayer</button>
    </div> : <p role="status" className="text-sm text-slate-600">Chargement du résumé…</p>}
  </section>;
  return <BillableCalculationPanel account={account} id={id} />;
}
